module.exports = function getResource(label, vars = []) {
    const resources = {
        allStores: 'Tous les magasins',
        chooseLocation: 'Choisir un lieu'
    };
    return resources[label];
};
